<template>
  <div>

    <v-sheet class="d-flex justify-center align-center py-16 section_first"  >
      <v-sheet color="transparent px-4 pt-9" min-height="200"  width="800">
        <h1 :style="`font-size : ${SM ? '18px' : ''}`"
            :class="[{'text-center' : SM}]"
            class="mt-8"
        >
          {{ $t('homepage_westudy.sections.features.title') }}
        </h1>

        <div>
          <h4 class="font-weight-medium  mt-3" :class="[{'text-center' : SM}]" style="color: #7a7a7a ; max-width: 600px" >
            {{ $t('homepage_westudy.sections.features.text') }}
          </h4>
        </div>
      </v-sheet>
    </v-sheet>

    <v-sheet class="d-flex justify-center align-center py-16 pt-0 px-4 "  >
      <v-sheet color="transparent" class="px-4" width="800">
        <h1 :style="`font-size : ${SM ? '18px' : ''}`"  :class="[{'text-center' : SM}]"  class="mt-16" >
          {{ $t('AboutUs') }}
        </h1>

<!--        <h4 class="font-weight-medium  mt-3" :class="[{'text-center' : SM}]" style="color: #7a7a7a ; max-width: 600px" >-->
<!--          Серед партнерських університетів, які консультували нашу команду та зараз користуються платформою WeStudy ™ можна виділити:-->
<!--        </h4>-->


        <p class="mt-4">Серед партнерських університетів, які консультували нашу команду та зараз користуються платформою WeStudy ™ можна виділити:</p>


        <p></p>
        <ul style="list-style-type: square;">
          <li>
              Національний університет «Львівська Політехніка»
          </li>
          <li>Волинський національний університет імені Лесі Українки </li>
          <li>Університет Григорія Сковороди у Переяславі </li>
          <li>Миколаївський національний університет імені В.О. Сухомлинського </li>
          <li>Уманський державний педагогічний університет імені Павла Тичини </li>
          <li>та інші.</li>
        </ul>
        <p class="mt-4">Проект <strong>WeStudy™</strong> бере початок із 2017 року, в якому було започатковано платформу супроводження міжнародних навчальних програм подвійних дипломів між університетами України та іноземних партнерів. За цей час проект виділився в окрему IT-компанію, яка зарекомендувала себе надійним партнером в сфері цифровізації процесів вищої освіти серед багатьох провідних університетів України та іноземних закладів освіти.</p>

        <p>Розробниками платформи є команда вчених, менеджерів та програмістів які багато років працювали в університетах на адміністративних посадах, мають великий досвід викладання. Ми добре знаємо специфіку роботи університетів з усіх боків та знаємо що необхідно для полегшення роботи як викладацького складу так і адміністрації. Окрему увагу ми приділяємо комфорту користування платформою безпосередньо студентом, адже саме студенти є кінцевими споживачами навчальних послуг університету.</p>
        <p><strong>WeStudy™</strong> - унікальна інтегрована онлайн платформа для закладів освіти. Сучасні рішення для ведення навчального процесу як класичного, так і дистанційного, просування послуг закладу освіти на світовому ринку освітніх та наукових послуг. Онлайн навчання, електронна залікова книжка із інтеграцією з деканатом, динамічний розклад для викладачів та студентів, система бухгалтерії із функцією сплати за навчання через мобільний додаток, ефективний документообіг, система набору абітурієнтів на території України та світу, розгорнутий блок оповіщень користувачів та багато інших найновітніших рішень - це <strong>WeStudy™</strong>.</p>

        <p>Ми постійно вдосконалюємо нашу платформу у відповідності до побажань замовників;</p>
        <h3 class="text-center font-weight-light mt-9">Свідоцтво на торговельну марку України <strong>№ 310596</strong></h3>
        <h3 class="text-center font-weight-light mb-6">Ідентифікаційний код юридичної особи <strong>№ 44338526</strong></h3>
      </v-sheet>
    </v-sheet>

<!--    <div class="d-flex flex-wrap">-->
<!--      <img class="wsRoundedHalf" src="https://api.westudy.ua/images/documentation/blob(1).jpg" alt="WeStudy™ - унікальна інтегрована онлайн платформа для закладів освіти. Свідоцтво на торговельну марку України № 310596" width="100%">-->
<!--      <h5 class="text-center font-weight-light mt-4">Свідоцтво про торгівельну марку</h5>-->
<!--      <v-sheet light class="mt-6 pa-6 wsRoundedHalf">-->
<!--        <img  src="https://api.westudy.ua/images/documentation/blob(8).png" alt="WeStudy™ - унікальна інтегрована онлайн платформа для закладів освіти. Свідоцтво на торговельну марку України № 310596" width="100%">-->
<!--      </v-sheet>-->
<!--      <h5 class="text-center font-weight-light mt-4">Відомості про торгівельну марку</h5>-->
<!--    </div>-->





  </div>
</template>

<script>
export default {
  name: "HomeAbout"
}
</script>

<style scoped>
h4 {
  font-size: 14px !important;
}

.section_first {
  background-image: url('~@/assets/img/bg-pages.jpg');
  background-position: center center;
  position: relative;
  background-size: cover;
}
</style>